"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/lib/auth";

export default function HomePage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  // Landing în funcție de rol: adminii pe dashboard, restul pe Head 10
  // (userii și editorii nu au acces la dashboard).
  useEffect(() => {
    if (loading) return;
    if (!user) {
      router.replace("/login");
      return;
    }
    router.replace(user.permissions?.includes("dashboard.view") ? "/dashboard" : "/head");
  }, [user, loading, router]);

  return null;
}
